// core

import http from '../api/http' 

const actions = {
    setMenu(context, menu) {
        context.commit('updateMenu', menu)
    }, 
    setMsg(context, msg) {
        context.commit('updateMsg', msg)
    },
    getPolling(context) {
		return new Promise((resolve, reject) => {
            resolve('tick')
		})
    },

    getCfgs(context) {
		return new Promise((resolve, reject) => {
			http.get('/api/cfgs')
			.then((response) => {
		    	if(response.data instanceof Object) {
					context.commit('getCfgs', response.data)
		    	} else reject(response)
				resolve(response)
			})
			.catch((error) => {
				console.log(error)
				reject(error)
			});
		})
    },

    async saveItem(context, param) {
    	console.log('action->saveItem')
		try {
			const response = await http.post('/api/printtext', param.data)
			return response
		} catch (error) {
			//console.error(error)
			throw error
			//return error
		} finally {
			//console.log('request done.')
		}
    },

    async printItem(context, param) {
    	console.log('action->printItem')
		try {
			const response = await http.post('/api/printhtml', param.data)
			return response
		} catch (error) {
			//console.error(error)
			throw error
			//return error
		} finally {
			//console.log('request done.')
		}
    },

}

export default actions;